"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var service_service_1 = require("../Services/service.service");
var i0 = require("@angular/core");
var i1 = require("../Services/service.service");
var Over18Guard = /** @class */ (function () {
    function Over18Guard(services) {
        this.services = services;
    }
    Over18Guard.prototype.canActivate = function (next, state) {
        var _this = this;
        return new Promise(function (rs, rj) {
            _this.services.disclaimerIsReady = false;
            if (_this.services.Over18Years) {
                _this.services.disclaimerIsReady = true;
                return rs(true);
            }
            else {
                _this.services.over18Change.subscribe(function (value) {
                    return rs(value);
                });
                if (next.url.length > 0) {
                    var oldUrl = next.url.map(function (u) { return u.path; }).join("/");
                    _this.services.showEnterDialog(oldUrl);
                }
                else {
                    _this.services.showEnterDialog("");
                }
            }
            ;
        });
    };
    Over18Guard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Over18Guard_Factory() { return new Over18Guard(i0.ɵɵinject(i1.MainService)); }, token: Over18Guard, providedIn: "root" });
    return Over18Guard;
}());
exports.Over18Guard = Over18Guard;
